var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[(_vm.ready)?_c('PublicIntro',{attrs:{"clients":_vm.clients}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }